import React from 'react';
import Svg, { Path, G, Defs, LinearGradient, Stop } from 'react-native-svg';

export interface NoPropertiesIllustrationProps {
    width?: number;
    height?: number;
}

/**
 * Building-with-clouds illustration for the "No Properties Yet" empty state.
 */
export function NoPropertiesIllustration({
    width = 172,
    height = 129,
}: Readonly<NoPropertiesIllustrationProps>) {
    return (
        <Svg width={width} height={height} viewBox="0 0 172 129" fill="none">
            <Path
                fill="#fff"
                d="M90.09 121.836c29.699 0 53.899-24.1 53.899-53.7-.1-29.7-24.2-53.8-53.9-53.8-29.8 0-53.9 24.1-53.9 53.7 0 29.7 24.1 53.8 53.9 53.8Z"
            />
            <G>
                <Path
                    fill="url(#b)"
                    d="M73.168 81.844c0 4.65-3.76 8.41-8.45 8.41H36.496c-5.62.121-10.108-4.367-10.108-9.785 0-5.458 4.528-9.986 10.229-9.703 4.892-15.283 27.29-13.14 29.191 2.668 4.205.526 7.359 4.084 7.359 8.41Z"
                />
            </G>
            <Path
                fill="url(#c)"
                d="M64.718 90.257c4.65 0 8.45-3.76 8.45-8.41s-3.8-8.41-8.45-8.41c-4.65 0-8.45 3.76-8.45 8.41s3.8 8.41 8.45 8.41Z"
            />
            <Path
                fill="url(#d)"
                d="M50.931 90.336c8.288 0 15.04-6.712 15.04-15s-6.752-15-15.04-15-15.04 6.712-15.04 15 6.711 15 15.04 15Z"
            />
            <G>
                <Path
                    fill="url(#f)"
                    d="M86.533 40.623c0 6.414-5.187 11.601-11.657 11.601H35.944C28.191 52.392 22 46.2 22 38.726c0-7.53 6.247-13.776 14.111-13.386 6.75-21.084 37.65-18.127 40.271 3.681 5.8.725 10.151 5.634 10.151 11.602Z"
                />
            </G>
            <Path
                fill="url(#g)"
                d="M74.876 52.223c6.414 0 11.657-5.188 11.657-11.602 0-6.414-5.243-11.602-11.657-11.602s-11.657 5.188-11.657 11.602c0 6.414 5.243 11.602 11.657 11.602Z"
            />
            <Path
                fill="url(#h)"
                d="M55.856 52.335c11.434 0 20.75-9.258 20.75-20.693 0-11.434-9.316-20.693-20.75-20.693s-20.749 9.26-20.749 20.693c0 11.435 9.26 20.693 20.75 20.693Z"
            />
            <G>
                <Path
                    fill="url(#j)"
                    fillRule="evenodd"
                    d="M75.184 35.093A3.35 3.35 0 0 0 70.87 38.3v63.074h11.725V89.65c0-1.85 1.5-3.35 3.35-3.35h6.7c1.85 0 3.35 1.5 3.35 3.35v11.725h11.725V47.346a3.35 3.35 0 0 0-2.387-3.208l-30.15-9.045Zm7.412 19.382c-.925 0-1.675.75-1.675 1.675v3.35c0 .925.75 1.675 1.675 1.675h3.35c.925 0 1.675-.75 1.675-1.675v-3.35c0-.925-.75-1.675-1.675-1.675h-3.35ZM80.921 66.2c0-.925.75-1.675 1.675-1.675h3.35c.925 0 1.675.75 1.675 1.675v3.35c0 .925-.75 1.675-1.675 1.675h-3.35c-.925 0-1.675-.75-1.675-1.675V66.2Zm1.675 8.375c-.925 0-1.675.75-1.675 1.675v3.35c0 .925.75 1.675 1.675 1.675h3.35c.925 0 1.675-.75 1.675-1.675v-3.35c0-.925-.75-1.675-1.675-1.675h-3.35Zm8.375-18.425c0-.925.75-1.675 1.675-1.675h3.35c.925 0 1.675.75 1.675 1.675v3.35c0 .925-.75 1.675-1.675 1.675h-3.35c-.925 0-1.675-.75-1.675-1.675v-3.35Zm1.675 8.375c-.925 0-1.675.75-1.675 1.675v3.35c0 .925.75 1.675 1.675 1.675h3.35c.925 0 1.675-.75 1.675-1.675V66.2c0-.925-.75-1.675-1.675-1.675h-3.35ZM90.971 76.25c0-.925.75-1.675 1.675-1.675h3.35c.925 0 1.675.75 1.675 1.675v3.35c0 .925-.75 1.675-1.675 1.675h-3.35c-.925 0-1.675-.75-1.675-1.675v-3.35Z"
                    clipRule="evenodd"
                />
                <Path
                    fill="url(#k)"
                    d="M67.522 101.38V44.43h-5.025a3.35 3.35 0 0 0-3.35 3.35v50.25h-1.675a1.675 1.675 0 0 0 0 3.35h10.05Z"
                />
                <Path
                    fill="url(#l)"
                    d="M121.122 101.381h-10.05V57.098l6.687 3.82a3.35 3.35 0 0 1 1.688 2.91V98.03h1.675a1.675 1.675 0 0 1 0 3.35Z"
                />
                <Path fill="url(#m)" d="M92.647 101.381V89.656h-6.7v11.725h6.7Z" />
            </G>
            <G>
                <Path
                    fill="url(#o)"
                    d="M149.388 85.242c0 4.65-3.76 8.41-8.45 8.41H112.717c-5.62.121-10.108-4.367-10.108-9.784 0-5.459 4.529-9.987 10.229-9.704 4.893-15.283 27.292-13.14 29.192 2.669 4.205.525 7.358 4.083 7.358 8.41Z"
                />
            </G>
            <Path
                fill="url(#p)"
                d="M140.938 93.655c4.65 0 8.451-3.76 8.451-8.41 0-4.649-3.801-8.41-8.451-8.41-4.649 0-8.45 3.761-8.45 8.41 0 4.65 3.801 8.41 8.45 8.41Z"
            />
            <Path
                fill="url(#q)"
                d="M127.152 93.734c8.288 0 15.04-6.711 15.04-15 0-8.288-6.752-15-15.04-15-8.289 0-15.041 6.712-15.041 15 0 8.289 6.712 15 15.041 15Z"
            />
            <Defs>
                <LinearGradient id="b" x1={49.778} x2={49.763} y1={72.721} y2={90.578} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#fff" />
                    <Stop offset={0.996} stopColor="#ECF0F5" />
                </LinearGradient>
                <LinearGradient id="c" x1={55.368} x2={62.859} y1={71.627} y2={79.82} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#BCCBE1" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient id="d" x1={34.482} x2={46.289} y1={68.453} y2={73.073} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#E2E8F0" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient id="f" x1={54.267} x2={54.246} y1={28.037} y2={52.672} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#fff" />
                    <Stop offset={0.996} stopColor="#ECF0F5" />
                </LinearGradient>
                <LinearGradient id="g" x1={61.978} x2={72.312} y1={26.522} y2={37.824} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#BCCBE1" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient id="h" x1={33.164} x2={49.452} y1={22.147} y2={28.521} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#E2E8F0" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient id="j" x1={89.299} x2={89.299} y1={37.257} y2={74.541} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#B0BACC" />
                    <Stop offset={1} stopColor="#969EAE" />
                </LinearGradient>
                <LinearGradient id="k" x1={61.66} x2={61.66} y1={46.408} y2={78.374} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#B0BACC" />
                    <Stop offset={1} stopColor="#969EAE" />
                </LinearGradient>
                <LinearGradient id="l" x1={116.936} x2={116.936} y1={58.636} y2={83.492} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#B0BACC" />
                    <Stop offset={1} stopColor="#969EAE" />
                </LinearGradient>
                <LinearGradient id="m" x1={89.298} x2={89.298} y1={90.064} y2={96.645} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#B0BACC" />
                    <Stop offset={1} stopColor="#969EAE" />
                </LinearGradient>
                <LinearGradient id="o" x1={125.999} x2={125.984} y1={76.119} y2={93.977} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#fff" />
                    <Stop offset={0.996} stopColor="#ECF0F5" />
                </LinearGradient>
                <LinearGradient id="p" x1={131.589} x2={139.08} y1={75.025} y2={83.218} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#BCCBE1" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient id="q" x1={110.703} x2={122.509} y1={71.851} y2={76.472} gradientUnits="userSpaceOnUse">
                    <Stop stopColor="#E2E8F0" />
                    <Stop offset={0.994} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
            </Defs>
        </Svg>
    );
}

export default NoPropertiesIllustration;
